export default __webpack_public_path__ + "static/media/img6.41392dff.jpg";